import axiosInstance from "../../axios/axiosInstance";
import {  DELETE_CHAT_SUPPORT, LIST_MESSAGE_SUPPORT, LIST_USER_MESSAGE_SUPPORT, MARK_AS_RESOLVED_SUPPORT, SEND_MESSAGE_SUPPORT } from "../../constants";

export const listMessageSuport = (props) => onResponse => {

    try {
        axiosInstance.post(LIST_MESSAGE_SUPPORT, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const listUserMessageSuport = (props) => onResponse => {

    try {
        axiosInstance.post(LIST_USER_MESSAGE_SUPPORT, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};


export const sendMessageSupport = (props) => onResponse => {

    try {
        axiosInstance.post(SEND_MESSAGE_SUPPORT, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};


export const markChatAsResolved = (props) => onResponse => {
    try {
        axiosInstance.post(MARK_AS_RESOLVED_SUPPORT, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) {
        // You might want to handle this error as well
        console.error("Error in markChatAsResolved:", error);
    }
};

export const deleteChat = (props) => onResponse => {
    try {
        axiosInstance.post(DELETE_CHAT_SUPPORT, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });
    } catch (error) {
        // You might want to handle this error as well
        console.error("Error in deleteChat:", error);
    }
};